import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { AvailabilityBase } from "../availability-base";
import { User } from "../user/entity";
import { UserAvailabilityEntityConfig } from "./config";
import { UserAvailabilityFilters } from "./filters";
import { UserAvailabilityMethods } from "./methods";

@HyperEntity<UserAvailability>(
  "user-availability",
  UserAvailabilityEntityConfig,
)
export class UserAvailability extends extender(
  UserAvailabilityFilters,
  UserAvailabilityMethods,
  AvailabilityBase,
) {
  @Fields.string({
    required: true,
    dbName: "user_id",
  })
  userId!: string;

  @Relations.toOne<UserAvailability, User>(() => User, "userId")
  user?: User;
}
